module.exports = __webpack_public_path__ + "static/header-3e37012b98b562b23f995664980468f1.png";